import { Attribute, Variant, Variations } from '@framework/model-types/Product'
import isEmpty from 'lodash/isEmpty'
import isEqual from 'lodash/isEqual'
import { Dispatch, SetStateAction } from 'react'

export const generateInitialAttributes = (
  variations: Variations,
  urlVariant: string | undefined,
  productAttributes: Attribute[],
  setSelectedVariation: Dispatch<SetStateAction<Variant | null>>,
  storeTemplate?: string,
) => {
  if (isEmpty(variations)) {
    return {}
  }

  if (urlVariant) {
    const attributeObj = urlVariant?.split(',')?.reduce((acc, variant) => {
      const [attributeId = '', optionId = ''] = variant?.split(':')

      return {
        ...acc,
        [attributeId]: optionId,
      }
    }, {})

    if (Object.keys(attributeObj).length === productAttributes?.length) {
      const selectedVariation = variations.find((variation: any) => {
        return isEqual(
          variation.keys.sort(),
          Object.values(attributeObj).sort(),
        )
      })

      if (selectedVariation) {
        setSelectedVariation(selectedVariation)
      } else {
        setSelectedVariation(null)
      }
    }
    return attributeObj
  }
  if (storeTemplate === 'ELEGANT') {
    const attrs = productAttributes.reduce((accumulator, attribute) => {
      return {
        ...accumulator,
        [attribute.name._id]: attribute?.options[0]?.id ?? '',
      }
    }, {})

    const selectedVariation = variations.find((variation: any) => {
      return isEqual(variation.keys.sort(), Object.values(attrs).sort())
    })
    if (selectedVariation) {
      setSelectedVariation(selectedVariation)
    } else {
      setSelectedVariation(null)
    }

    return attrs
  }

  return {}
}
